import { useState } from "react";
import axios from "axios";
import { z } from "zod";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ForgotPasswordSchema } from "@/schema";
import api from "@/store/api";

const useForgotPassword = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendForgotPasswordEmail = async (
    values: z.infer<typeof ForgotPasswordSchema>
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post("/web/auth/forgotPassword", values);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message || t("alerts.error.emailSendError")
        );
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };

  return { sendForgotPasswordEmail, isLoading, error };
};

export default useForgotPassword;
